<nav class="navbar navbar-expand-lg bg-body-tertiary navbar-light bg-light">
    <div class="topbar-main">
        <div>
            <a href="#" class="navbar-brand">
                <img src="assets/images/Menu_Icons/Mines_NxT_Logo.svg" class="avatar" alt="Avatar">
            </a>
        </div>

        <ng-container *ngIf="toShowCustomerName">
            <div class="clsUnitName" *ngIf=" this.selectedCustomer?.customerId ?  this.selectedCustomer.customerId : '' ">
                <div class="" *ngIf=" this.selectedUnit?.unitName ?  this.selectedUnit.unitName : '' ">
                    <span>{{this.selectedUnit.unitName}}</span>
                </div>
            </div>
        </ng-container>

        <div class="help-sec" *ngIf="toShowHelp">
            <!-- <a href="{{helpUrl}}" target="_blank">
                <i class="fa fa-question-circle help-icon" aria-hidden="true"></i>
                Help
            </a> -->
        </div>

        <ng-container *ngIf="toShowCustomerName">
            <div class="custName" *ngIf=" this.selectedCustomer?.customerId ?  this.selectedCustomer.customerId : '' ">
                <!-- <a routerLink="/customer-admin/view-units">
                    <img [src]="this.trustedDashboardUrl" class="img-logo" style="width: 32px;">
                </a> -->
                <a href="#">
                    <img [src]="this.trustedDashboardUrl" class="img-logo" style="width: 38px;">
                </a>
            </div>
        </ng-container>

        <!-- notifications code-->
        <div class="alert-sec" (click)="notificationShow = !notificationShow" *ngIf="isAlertNotificationIcon">
            <a class="bell-sec" id="defaultDropdown" aria-expanded="false">
                <i class="fa fa-bell-o"></i>
                <span class="position-absolute start-100 translate-middle badge rounded-pill"
                    *ngIf="notifymsg.length > 0">
                    {{notifymsg.length}}
                </span>
            </a>
            <div class="dropdown-menu drop_menu_notofication show" *ngIf="notificationShow">
                <div class="card-header">
                    You have {{notifymsg.length}} new notifications.
                </div>
                <div class="cardBody">
                    <div class="card-custom" *ngFor="let value of notifymsg">
                        <div class="container">
                            <img class="notification-icon" [src]=getImagePath(value.alertType) />
                            <span class="noti-name">{{value.name}}</span>
                            <p class="notification-ack">
                                {{value.date | dateAgo}}
                                <i class="fa fa-check-square-o icon notification-ack-icon" title="Acknowledge"
                                    (click)="acknowledge(value.notificationId)"></i>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <a class="card-link" [routerLink]="['view-notification']">View all notifications</a>
                </div>
            </div>
        </div>
        <div class="profile-sec">
            <!-- <button type="text" class="dropdown-toggle pro-btn" (click)="op.toggle($event)" #myover>
                <i class="fa fa-user profile_icon" aria-hidden="true" style="margin-right: 0px;"></i>
            </button> -->
            <button type="text" id="btn-prof" class="dropdown-toggle pro-btn" (click)="togglePanel($event,op)">
                <i class="fa fa-user profile_icon" id="myover" aria-hidden="true" style="margin-right: 0px;"></i>
            </button>
            <p-overlayPanel #op [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" [showCloseIcon]="false"
                [style]="{width: '180px'}" appendTo="self" styleClass="overly-menu" [dismissable]="false"
                class="overly-item">
                <ng-template pTemplate="content">
                    <ul class="ul-profile-item ">
                        <li class="bg_highlight">
                            <a (click)="ShowProfileDetails(0)" class="dropdown_item">
                                <img src="assets/images/profile_menu_icon/person_icon.svg" alt="" />
                                <span class="item-text">Profile </span>
                            </a>
                        </li>

                        <ng-container *ngIf="toShowProdConfig">
                            <li class="bg_highlight">

                                <a (click)="onRedirect(10)" class="router-link dropdown_item">

                                    <img src="assets/images/profile_menu_icon/config_icon.svg" alt="" />

                                    <span class="item-text">Product Config</span>
                                </a>
                            </li>
                        </ng-container>
                        <ng-container *ngIf="toShowUnitConfig">
                            <li class="bg_highlight">
                                <a (click)="onRedirect(11)" class="router-link dropdown_item">
                                    <img src="assets/images/profile_menu_icon/setting_icon.svg" alt="" />
                                    <span class="item-text">Unit Config</span>
                                </a>
                            </li>
                        </ng-container>
                        <li class="bg_highlight" (click)="toHideOverly($event)">
                            <a routerLink="/change-password" class="dropdown_item">
                                <img src="assets/images/profile_menu_icon/person_icon.svg" />
                                <span class="item-text">Change Password</span></a>
                        </li>
                        <li class="bg_highlight">
                            <a (click)="logout()" class="dropdown_item">
                                <i class="fa fa-sign-out sig-out"></i>
                                <span class="item-text">Logout</span>
                            </a>
                        </li>
                    </ul>
                </ng-template>
            </p-overlayPanel>

        </div>


    </div>

</nav>

<p-dialog [(visible)]="notificationRecommendation" [position]="'center'" [draggable]="false" [resizable]="false"
    [closeOnEscape]="false" [closable]="true" [style]="{width: '40vw'}" [baseZIndex]="10000" modal="true"
    dismissableMask="true">
    <div class="notifyRecommendation">
        <p class="reason-tittle">{{this.notificationDetailMsg?.message}}</p>
        <p>{{this.notificationDetailMsg?.date | date :'dd/MM/yyyy HH:mm:ss' }}</p>
        <button class="edit-button" type="button" (click)="ViewRecommendation()"> View Recommendation
        </button>
    </div>
</p-dialog>